import axios, { AxiosError } from "axios";
import { noop } from "lodash";
import { UseFormSetError } from "react-hook-form";

import { SNHUFormData } from "./components/survey-page/survey-page.component";
import { LeadCompletedResponse } from "./snhu.types";


export namespace SNHUService {
  export function postLead(payload: SNHUFormData, setError: UseFormSetError<SNHUFormData>): Promise<void> {
    return axios
      .post(
        `${window.FKL.yentaServicesApiUrl}/snhu/leads`,
        payload,
      )
      .then(noop)
      .catch((error: AxiosError) => {
        const status = error.response?.status;

        if (status === 422) {
          setError("root", {
            type: "manual",
            message: error.response?.data?.message ?? "Failed to submit. Please try again.",
          });

          return Promise.reject();
        }

        throw new Error(
          `Failed to post SNHU lead: ${error.response?.data?.message ?? error.message}`
        );
      });
  }

  export function getHasCompletedSNHU(email: string): Promise<boolean> {
    const params = { email };

    return axios
      .get<LeadCompletedResponse>(`${window.FKL.yentaServicesApiUrl}/snhu/leads`, {
        params,
      })
      .then((response) => response.data.has_completed_snhu)
      .catch((error) => {
        throw new Error(
          `Failed to get SNHU lead completed status: ${error.response?.data?.message ?? error.message}`
        );
      });
  }
}
